export default __webpack_public_path__ + "static/media/image-currency.1b385bf9.jpg";